// Import-free so the server, the pages and the tests all read the one value.

/** New organisations can connect. Left false while sign-ups are paused. The sign-up endpoints
 *  read this too, so pausing isn't just a hidden button. Flip it here (and deploy) to open. */
export const SIGNUPS_OPEN = false;
